import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Created in Error' },
    { value: 2, label: 'Destroyed' },
    { value: 3, label: 'Lost' },
    { value: 4, label: 'Miscellaneous' },
    { value: 5, label: 'Returned to Caregiver' },
    { value: 6, label: 'Medication Finished' },
  ],
});
